/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx';
import styles from './SystemMaintenance.module.css'; // Import CSS module
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';
import { handleLogout } from "../../utils/utils";

const SystemMaintenanceMsg = () => {
  const { user, logoutUser } = useAuthorizationContext();
  const baseUrl = useSelector(state => state.counter.baseUrl);  // useSelector
  const auth = useSelector((state) => state.auth);
  const status = auth?.recentStatus
  const dispatch = useDispatch()
  useEffect(() => {
    if (status === 503) {
      setTimeout(() => {
        handleLogout();
      }, 60000);
    }
  }, [status]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <div className={clsx(styles.background_container, styles.fadeIn)} />
      <h2 className={clsx(styles.mainTitle, styles.slideIn)}>ERC-Timetracker site is currently Under Maintenance!</h2>
      <div className={clsx(styles.pBlock1, styles.fadeIn, styles.slideIn)}>
        <p>ERC Timebooking System will not be available to end users</p>
        {/* <p>from 00:25 HRS to 01:25 HRS</p> */}
        <p>We regret the inconvenience caused!</p>
      </div>
      <div className={clsx(styles.pBlock1, styles.fadeIn, styles.slideIn)}>
        <p>Thank You!</p>
        <p>Time Tracker Team</p>
      </div>
    </div>
  );
}

export default SystemMaintenanceMsg;
